<template>
  <div class="header">
    <div class="header-content">
      <img
        @click="goHome()"
        class="logo"
        src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home2.png"
        alt=""
      />
      <!--  -->
      <div class="user-info" v-if="$token.isLogin()">
        <div class="user-box" @click="toggleDropdown">
          <img
            class="user-avatar"
            src="
              https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-16User001010.png
            "
            alt=""
          />
          <span class="username">WONZ_{{ JSON.parse(phone).slice(-4) }}</span>
        </div>
        <div class="dropdown" v-if="showDropdown">
          <div class="dropdown-menu">
            <div class="dropdown-item" @click="setPass">
              <img
                class="menu-icon"
                src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-16headerSet1.png"
                alt=""
              />
              <span>修改密码</span>
            </div>
            <div class="dropdown-item danger" @click="handleLogout">
              <img
                class="menu-icon"
                src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-16headerSet2.png"
                alt=""
              />
              <span>退出登录</span>
            </div>
          </div>
        </div>
      </div>
      <div class="user-info" v-else>
        <button class="login-btn mobile-only" @click="goToLogin">
          登录
          <img
            class="login-btn-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-9home9.png"
            alt=""
          />
        </button>

        <button class="login-btn pc-only" @click="goToLogin">
          <img
            class="login-btn-icon"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-16User12397.png"
            alt=""
          />
          登录
        </button>
      </div>
    </div>
    <confirmPop ref="confirmPop" @confirm="confirm"></confirmPop>
  </div>
</template>

<script>
import confirmPop from "@/components/confirmPop.vue";
import { logout } from "@/api/index";
export default {
  components: {
    confirmPop,
  },
  data() {
    return {
      show: "",
      phone: localStorage.getItem('phone'),
      showDropdown: false,
    };
  },
  mounted() {
    // 点击其他地方关闭下拉菜单
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    goHome() {
      // window.history.replaceState({}, document.title, "/");
      // this.$router.replace({ path: "/", force: true });
      // 1. 跳首页（replace替换当前记录）
      // this.$router.replace("/");
      // // 2. 清空history中除首页外的所有记录
      // window.history.go(-(window.history.length - 1));
      this.$router.replace("/");
    },
    setPass() {
      this.$router.replace({ path: "/SetPass" });
    },
    handleLogout () {
      this.$refs.confirmPop.open('退出登录', '您确定要退出登录吗？', "继续")
    },
    
    async confirm() {
      try {
        await logout({}).then((res) => {
          this.phone = '';
          this.$router.replace({ path: "/" });
          this.$token.remove();
          this.$toast.success("已退出登录");
          let inChina = JSON.parse(localStorage.getItem('inChina'))
          // 1. 清空localStorage（核心）
          localStorage.clear();

          // 2. 清空sessionStorage（可选，按需开启）
          sessionStorage.clear();
          localStorage.setItem('inChina', JSON.stringify(inChina))
        });
      } catch (e) {}
    },
    goToLogin() {
      
      if (!JSON.parse(localStorage.getItem("inChina"))) {
        this.$IpPop.open();
        return;
      }
      this.$router.replace("/Login");
    },
    goUrl2(url) {
      window.open(url);
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    handleClickOutside(e) {
      if (!e.target.closest(".user-info")) {
        this.showDropdown = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  /* ===== 头部 ===== */
  .header {
    width: 100%;
    background: #fff;
    box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 0.9rem 0;
    .header-content {
      max-width: 87.5rem;
      margin: 0 auto;
      padding: 0 2.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        width: 10.625rem;
        height: 1.5rem;
      }
      .user-info {
        position: relative;
        display: flex;
        align-items: center;
        .user-box {
          display: flex;
          align-items: center;
          gap: 0.625rem;
          padding: 0.5rem 0.6rem;
          background: #fff;
          border-radius: 2rem;
          cursor: pointer;
          transition: all 0.2s;
          border-radius: 3.75rem;
          border: 1px solid #f5f6fe;
          &:hover {
            box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
          }
          .user-avatar {
            width: 2.1rem;
            height: 2.1rem;
            border-radius: 50%;
            object-fit: cover;
          }
          .username {
            font-size: 1.1rem;
            color: #4e5361;
            font-weight: 500;
          }
        }
        .dropdown {
          position: absolute;
          top: 100%;
          right: 0;
          margin-top: 0.75rem;
          z-index: 1000;
          .dropdown-menu {
            background: #fff;
            border-radius: 0.9rem;
            box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.1);
            padding: 0.5rem 0;
            min-width: 11.25rem;
            .dropdown-item {
              display: flex;
              align-items: center;
              padding: 0.875rem 1.25rem;
              cursor: pointer;
              font-size: 1.1rem;
              color: #333;
              transition: background 0.2s;
              gap: 0.75rem;
              .menu-icon {
                width: 1.125rem;
                height: 1.125rem;
              }
              &:hover {
                background: #f5f7fa;
              }
            }

            .dropdown-item.danger {
              color: #e7000b;
              .menu-icon {
                opacity: 0.8;
              }
              &:hover {
                background: #fff0f0;
              }
            }
          }
        }

        .login-btn {
          font-weight: bold;
          font-size: 1rem;
          color: #ffffff;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
          transition: all 0.3s;

          width: 6.875rem;
          height: 2.875rem;
          background: #0074fc;
          border-radius: 0.75rem;
          display: flex;
          align-items: center;
          justify-content: center;
          .login-btn-icon {
            width: 0.75rem;
            height: 0.625rem;
            margin-left: 0.9375rem;
          }
        }
        .pc-only {
          display: none;
        }
        .login-btn:hover {
          background: #1976d2;
        }
      }
    }
  }
}
@media all and (max-width: 767px) {
  /* ===== 头部 ===== */
  .header {
    width: 100%;
    height: 8.5rem;
    background: #fff;
    box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.05);
    position: sticky;
    top: 0;
    z-index: 100;
    padding: 3.5rem 0;
    box-sizing: border-box;
    .header-content {
      max-width: 87.5rem;
      margin: 0 auto;
      padding: 0 2.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .logo {
        width: 10.625rem;
        height: 1.5rem;
      }
      .user-info {
        position: relative;
        display: flex;
        align-items: center;
        .user-box {
          display: flex;
          align-items: center;
          gap: 0.625rem;
          padding: 0.5rem 0.6rem;
          background: #fff;
          border-radius: 2rem;
          cursor: pointer;
          transition: all 0.2s;
          border-radius: 3.75rem;
          // border: 1px solid #f5f6fe;
          // &:hover {
          //   box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
          // }
          .user-avatar {
            width: 3rem;
            height: 3rem;
            border-radius: 50%;
            object-fit: cover;
          }
          .username {
            font-size: 1.75rem;
            color: #4e5361;
            font-weight: 500;
          }
        }
        .dropdown {
          position: absolute;
          top: 100%;
          right: 0;
          margin-top: 0.75rem;
          z-index: 1000;
          .dropdown-menu {
            background: #fff;
            border-radius: 0.9rem;
            box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.1);
            padding: 0.5rem 0;
            min-width: 11.25rem;
            .dropdown-item {
              display: flex;
              align-items: center;
              padding: 0.875rem 1.25rem;
              cursor: pointer;
              font-size: 1.5rem;
              color: #333;
              transition: background 0.2s;
              gap: 0.75rem;
              .menu-icon {
                width: 1.7rem;
                height: 1.7rem;
              }
              &:hover {
                background: #f5f7fa;
              }
            }

            .dropdown-item.danger {
              color: #e7000b;
              .menu-icon {
                opacity: 0.8;
              }
              &:hover {
                background: #fff0f0;
              }
            }
          }
        }

        .login-btn {
          font-weight: bold;
          font-size: 1.75rem;
          color: #101424ff;
          font-style: normal;
          text-transform: none;
          cursor: pointer;
          transition: all 0.3s;

          width: 7rem;
          height: 2.875rem;
          border-radius: 0.75rem;
          display: flex;
          align-items: center;
          justify-content: center;
          .login-btn-icon {
            width: 2rem;
            height: 1.8rem;
            margin-right: 0.6rem;
          }
        }
        .mobile-only {
          display: none;
        }
      }
    }
  }
}
</style>